export const blogPosts = [
  {
    id: 1,
    key: "choosingCylinder",
    date: "2026-05-15",
    image: "https://readdy.ai/api/search-image?query=Modern%20sleek%20silver%20cylinder%20lock%20mechanism%20close-up%20with%20a%20contemporary%20brushed%20metal%20key%20partially%20inserted%2C%20clean%20dark%20charcoal%20background%2C%20cool%20professional%20studio%20lighting%20with%20soft%20silver%20reflections%2C%20minimalist%20product%20photography%2C%20high-end%20security%20hardware%20aesthetic%2C%20smooth%20metallic%20surfaces%20with%20subtle%20grain%20texture%2C%20sophisticated%20contemporary%20design%2C%20precision%20engineering%20visible%20in%20the%20lock%20mechanism&width=600&height=600&seq=blog-modern-01-v3&orientation=squarish",
    slug: "choosing-right-cylinder",
    author: "Clefs de Lys SA",
  },
  {
    id: 2,
    key: "keyTech2026",
    date: "2026-04-28",
    image: "https://readdy.ai/api/search-image?query=Modern%20smart%20digital%20lock%20panel%20and%20sleek%20titanium%20key%20fob%20side%20by%20side%20on%20dark%20slate%20surface%2C%20cool%20split%20lighting%20with%20blue-white%20tech%20glow%20and%20crisp%20silver%20metallic%20highlights%2C%20contemporary%20still%20life%20photography%2C%20striking%20contrast%20between%20physical%20modern%20key%20and%20digital%20interface%2C%20clean%20dark%20background%20with%20cool%20metallic%20reflections%2C%20futuristic%20security%20technology%20aesthetic&width=600&height=600&seq=blog-modern-02-v3&orientation=squarish",
    slug: "evolution-key-technology-2026",
    author: "Clefs de Lys SA",
  },
  {
    id: 3,
    key: "cylinderReplacement",
    date: "2026-04-10",
    image: "https://readdy.ai/api/search-image?query=Worn%20modern%20silver%20lock%20cylinder%20with%20visible%20scratches%20next%20to%20a%20pristine%20new%20replacement%20cylinder%20on%20dark%20charcoal%20surface%2C%20dramatic%20overhead%20studio%20lighting%20creating%20clean%20defined%20shadows%2C%20contemporary%20product%20photography%2C%20cool%20silver%20metallic%20tones%20contrasting%20against%20the%20dark%20minimalist%20backdrop%2C%20precision%20engineering%20details%20in%20sharp%20focus%2C%20premium%20security%20hardware%20comparison%20aesthetic&width=600&height=600&seq=blog-modern-03-v3&orientation=squarish",
    slug: "signs-cylinder-needs-replacement",
    author: "Clefs de Lys SA",
  },
  {
    id: 4,
    key: "masterKeySystems",
    date: "2026-03-22",
    image: "https://readdy.ai/api/search-image?query=Set%20of%20modern%20sleek%20silver%20keys%20of%20varying%20sizes%20arranged%20in%20a%20precise%20geometric%20fan%20pattern%20on%20dark%20slate%20surface%2C%20cool%20dramatic%20overhead%20lighting%20creating%20crisp%20elegant%20shadows%2C%20contemporary%20minimalist%20product%20photography%2C%20brushed%20metal%20silver%20tones%20against%20clean%20dark%20charcoal%20background%2C%20premium%20modern%20security%20aesthetic%2C%20laser-cut%20key%20details%20visible%2C%20sophisticated%20geometric%20composition&width=600&height=600&seq=blog-modern-04-v3&orientation=squarish",
    slug: "master-key-systems-explained",
    author: "Clefs de Lys SA",
  },
  {
    id: 5,
    key: "electricalCylinders",
    date: "2026-07-15",
    image: "https://readdy.ai/api/search-image?query=Modern%20electronic%20access%20control%20cylinder%20lock%20with%20sleek%20dark%20titanium%20metal%20finish%20and%20a%20subtle%20glowing%20LED%20indicator%20ring%2C%20a%20contemporary%20electronic%20key%20fob%20resting%20beside%20it%2C%20clean%20dark%20charcoal%20studio%20background%2C%20cool%20professional%20lighting%20with%20crisp%20silver%20metallic%20reflections%2C%20premium%20security%20technology%20aesthetic%2C%20minimalist%20product%20photography%2C%20precision%20mechatronic%20engineering%20details%20in%20sharp%20focus&width=600&height=600&seq=blog-electrical-cyl-01&orientation=squarish",
    slug: "electrical-cylinders-access-control",
    author: "Clefs de Lys SA",
  },
];

export const companyStats = [
  { value: "25+", label: "Years of Experience" },
  { value: "10k+", label: "Keys Cut Annually" },
  { value: "98%", label: "Client Satisfaction" },
  { value: "500+", label: "Business Partners" },
];

export const services = [
  {
    icon: "ri-key-2-line",
    title: "Precision Key Cutting",
    description: "High-precision key duplication using state-of-the-art machinery for all major brands and custom profiles.",
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "Cylinder Systems",
    description: "Premium cylinder locks and complete security systems for residential, commercial, and industrial applications.",
  },
  {
    icon: "ri-building-line",
    title: "Master Key Solutions",
    description: "Custom master key hierarchies designed for property managers, hotels, and large facilities.",
  },
  {
    icon: "ri-tools-line",
    title: "Repair & Installation",
    description: "Professional lock repair, replacement, and new installation services with rapid response times.",
  },
];

export const navLinks = [
  { label: "Home", href: "/" },
  { label: "Blog", href: "/blog" },
  { label: "Partners", href: "/partners" },
  { label: "Contact", href: "/contact" },
];

export const priorityPartners = [
  {
    name: "Dormakaba AG",
    logo: "https://public.readdy.ai/ai/img_res/d5659e2c-d0cf-4021-a7f8-4ce58d0927fa.png",
    description: "Global leader in access and security solutions, formed from the merger of Dorma and Kaba. Their cylinder systems are industry benchmarks for reliability and innovation.",
    location: "Rümlang, Switzerland",
    founded: "2015 (merger), roots back to 1862",
    website: "https://www.dormakaba.com/ch-en",
    products: ["Mechanical cylinders", "Electronic access systems", "Master key systems", "Hotel locking solutions"],
    boostXl: true,
  },
  {
    name: "SEA Schliess-Systeme AG",
    logo: "https://www.sea.ch/includes/Layout/default/images/logoBig.png",
    description: "Swiss manufacturer specializing in high-quality locking systems and security hardware for residential, commercial, and industrial applications across Switzerland.",
    location: "Burgdorf, Switzerland",
    founded: "1946",
    website: "https://www.sea.ch/",
    products: ["Cylinder locks", "Padlocks", "Furniture locks", "Special security solutions"],
  },
  {
    name: "KESO (ASSA ABLOY)",
    logo: "https://gw-assets.assaabloy.com/is/content/assaabloy/assa-abloy-deep-blue-logo",
    description: "Premium Swiss security brand under the ASSA ABLOY group, renowned for patented reversible key systems and high-security cylinders trusted by government and financial institutions worldwide.",
    location: "Richterswil, Switzerland",
    founded: "1963",
    website: "https://www.assaabloy.com/ch/en",
    products: ["KESO 8000 Omega", "KESO 4000", "Patented key systems", "High-security cylinders"],
  },
  {
    name: "DOM Schweiz AG",
    logo: "https://p-cdn-sfpi.azureedge.net/ch/de/-/media/DOM/DOM-Global/Image/Logos/dom-security-logo.svg?modified=20180808110051&extension=webp&modified=20180808110051",
    description: "Innovative Swiss security company offering intelligent mechatronic locking solutions, combining mechanical precision with digital access control for modern security needs.",
    location: "Brügg, Switzerland",
    founded: "1937",
    website: "https://www.dom-security.com/ch/de",
    products: ["Mechatronic cylinders", "Digital access control", "Mechanical locking systems", "Emergency exit systems"],
    boost: true,
  },
  {
    name: "EVVA",
    logo: "https://public.readdy.ai/ai/img_res/7b46569f-a3e6-4052-b1df-9181d8d57416.png",
    description: "Austrian security technology pioneer with over a century of expertise, famous for their slider-based MCS system and innovative mechanical security solutions sold worldwide.",
    location: "Vienna, Austria",
    founded: "1919",
    website: "https://www.evva.com/ch-de/",
    products: ["MCS magnetic coding system", "EPS electronic cylinders", "3KS sliders system", "Access management software"],
  },
];

export const partners = [
  {
    name: "OPO Oeschger AG",
    note: "",
    website: "https://www.opo.ch/de/",
    logo: "https://public.readdy.ai/ai/img_res/baf5db98-cb36-4c21-992b-8d6649ed6c1f.png",
    darkLogo: false,
  },
  {
    name: "JOGGI AG",
    note: "",
    website: "https://www.joggi.ch/",
    logo: "https://public.readdy.ai/ai/img_res/47c07ce3-c4d2-4b8c-9708-04894847947e.png",
    darkLogo: false,
  },
  {
    name: "KOCH Group AG",
    note: "",
    website: "https://www.koch.ch/fr/",
    logo: "https://storage.readdy-site.link/project_files/323176dc-da2c-4a55-967c-29f9c79c32e7/8a89a111-f999-4267-8ed9-9c254523f352_compressed_Screenshot_12.webp",
    darkLogo: false,
    boostXl: true,
  },
  {
    name: "SFS Group AG",
    note: "",
    website: "https://www.sfs.com/ch/en",
    logo: "https://www.sfs.com/layout/assets/images/sfs_logosvg.svg",
    darkLogo: true,
    darkCard: true,
  },
  {
    name: "Ernst Schweizer AG",
    note: "",
    website: "https://www.ernstschweizer.ch/de/",
    logo: "https://www.ernstschweizer.ch/wp-content/themes/station-modular/dist/assets/images/logo.svg",
    darkLogo: true,
  },
  {
    name: "Jean Musina SA",
    note: "",
    website: "https://www.musina.ch/",
    logo: "https://www.musina.ch/wp-content/uploads/2018/10/En-tête-V1.png",
    darkLogo: false,
    boost: true,
  },
  {
    name: "3CService SA",
    note: "",
    website: "https://www.3cservices.ch/",
    logo: "https://www.3cservices.ch/wp-content/themes/yootheme/cache/f8/3C_logo_2020-f8b3aa27.png",
    darkLogo: false,
  },
  {
    name: "Drawag AG",
    note: "",
    website: "https://drawag.ch/de-ch/",
    logo: "https://public.readdy.ai/ai/img_res/ad95e611-8d9c-4ef0-baab-69924942dc77.png",
    darkLogo: false,
    boost: true,
  },
  {
    name: "Portes Brodard SA",
    note: "",
    website: "https://portes-brodard.ch/",
    logo: "https://public.readdy.ai/ai/img_res/156ef5a5-0769-46e9-a701-9b926536d9cf.png",
    darkLogo: false,
    boost: true,
  },
  {
    name: "Jansen AG",
    note: "",
    website: "https://www.jansen.com/en/index.html",
    logo: "https://public.readdy.ai/ai/img_res/cf08eefa-a1c0-44b3-8528-168505917aad.png",
    darkLogo: false,
    boost: true,
  },
  {
    name: "Roto",
    note: "",
    website: "https://ftt.roto-frank.com/de-de/",
    logo: "https://public.readdy.ai/ai/img_res/85269249-073e-49de-b694-04d2287c2233.png",
    darkLogo: false,
  },
];

export const realEstatePartners = [
  {
    name: "Gerama Immobilier",
    note: "",
    website: "https://gerama.ch/",
    logo: "https://gerama.ch/wp-content/uploads/2020/05/logoSmall.png",
    darkLogo: false,
  },
  {
    name: "Régie de Fribourg S.A.",
    note: "",
    website: "https://www.rfsa.ch/fr",
    logo: "https://public.readdy.ai/ai/img_res/277d72ab-3e44-4648-9e3e-fa37e2d47980.png",
    darkLogo: false,
    boostXl: true,
  },
  {
    name: "Apleona Suisse SA",
    note: "",
    website: "https://apleona.ch/fr/",
    logo: "https://public.readdy.ai/ai/img_res/db2d51ad-3fa9-4fe9-a990-4e26168f39c9.png",
    darkLogo: false,
    boostXl: true,
  },
  {
    name: "BD Gérance SA",
    note: "",
    website: "https://bdgerance.ch/",
    logo: "https://public.readdy.ai/ai/img_res/c354c192-9235-4599-aacc-22c201dae3a6.png",
    darkLogo: false,
    boostXl: true,
  },
  {
    name: "Naef Immobilier",
    note: "",
    website: "https://www.naef.ch/",
    logo: "https://www.naef.ch/wp-content/themes/naefv2/assets/images/naef-logo.png",
    darkLogo: false,
  },
  {
    name: "Gruyère-Immo SA",
    note: "",
    website: "https://www.gruyere-immo.ch/",
    logo: "https://www.gruyere-immo.ch/files/build/GISA-Logo-20ANS-blanc.svg",
    darkLogo: true,
    darkCard: true,
  },
  {
    name: "Weck Aeby & Cie SA",
    note: "",
    website: "https://www.weck-aeby.ch/",
    logo: "https://www.weck-aeby.ch/wp-content/themes/theme/assets/images/logo.svg",
    darkLogo: true,
    darkCard: true,
  },
  {
    name: "Gérances Giroud SA",
    note: "",
    website: "https://www.gerances-giroud.ch/",
    logo: "https://storage.helloreaddy.io/project_files/323176dc-da2c-4a55-967c-29f9c79c32e7/11c6aab7-2f1e-47c3-9f64-0c55caf104ba_compressed_ChatGPT-Image-Aug-22-2026-10_17_20-PM.webp",
    darkLogo: false,
    boostXl: true,
  },
  {
    name: "Bulliard Immobilier SA",
    note: "",
    website: "https://www.bulliard.ch/immobilier/home",
    logo: "https://www.immomigimg.ch/s/a8da0/133/websites/logos/133_3212_98763f93cb48f27858d34d1a69d970060709045c.svg",
    darkLogo: true,
    darkCard: true,
  },
  // --- Real estate partners added with real logos ---
  {
    name: "Sallin Immobilien",
    note: "",
    website: "https://www.sallin-immobilier.ch/fr",
    logo: "https://www.immomigimg.ch/s/3de70/537/websites/logos/537_4834_dc390089c825153733c5e480214678463c7b16f6.png",
    darkLogo: false,
    boostXl: true,
  },
  {
    name: "Privera SA",
    note: "",
    website: "https://www.privera.ch/",
    logo: "https://www.privera.ch/design/img/logo.png",
    darkLogo: true,
    darkCard: true,
  },
  {
    name: "Régie Gestina SA",
    note: "",
    website: "https://www.gestina.ch/",
    logo: "https://www.gestina.ch/images/logo_gestina.svg",
    darkLogo: true,
    darkCard: true,
  },
  {
    name: "Vimova",
    note: "",
    website: "https://www.vimova.ch/",
    logo: "https://vimova.ch/wp-content/uploads/2024/12/vimova_logo_v01.svg",
    darkLogo: true,
    darkCard: true,
  },
  {
    name: "CF Immobilier",
    note: "",
    website: "https://www.cfimmobilier.ch/fr",
    logo: "https://www.immomigimg.ch/s/2a7cb/145/websites/logos/145_2613_d154e94ef35aacaff95c350d53dc0e6d3c1957cf.svg",
    darkLogo: false,
  },
  {
    name: "Gérance Hirt",
    note: "",
    website: "https://www.gerance-hirt.ch/",
    logo: "https://www.immomigimg.ch/s/d2ff9/924/websites/logos/924_2801_04ef0b86ed70e580dfc70832825252d94e2ad2b6.svg",
    darkLogo: false,
  },
  {
    name: "Gérances Foncières S.A.",
    note: "",
    website: "https://www.gerances-foncieres.ch/",
    logo: "https://public.readdy.ai/ai/img_res/2afb3be5-87a8-4d45-8cbd-7f0a7bb4b06e.png",
    darkLogo: false,
  },
  {
    name: "SA Régie du Rhône",
    note: "",
    website: "https://www.gerofinance.ch/",
    logo: "https://www.gerofinance.ch/upload4mail/gerofinance/v/l/k/s/u/b_VLKsU_gerofinance_logotype.svg",
    darkLogo: true,
    darkCard: true,
  },
  {
    name: "COGESTIM SA",
    note: "",
    website: "https://www.cogestim.ch/",
    logo: "https://cogestim.ch/wp-content/uploads/2025/11/Couleur_logo_sans_ligne_web.svg",
    darkLogo: false,
  },
  {
    name: "JPF Immobilier SA",
    note: "",
    website: "https://www.jpf-immobilier.ch/",
    logo: "https://www.jpf-immobilier.ch/files/fz-static/assets/JPF_logo.YPfp8Ja_.svg",
    darkLogo: true,
    darkCard: true,
  },
  {
    name: "LB Gérance",
    note: "",
    website: "https://lb-gerance.ch/",
    logo: "https://lb-gerance.ch/wp-content/uploads/2026/01/LBG-Logo-RVB.svg",
    darkLogo: false,
  },
  {
    name: "OK Immobilien",
    note: "",
    website: "https://www.ok-immobilienmakler.de/",
    logo: "https://static.wixstatic.com/media/2e0c5b_390afd3060c2419f9236575f2bd51ed1~mv2_d_1721_1434_s_2.png/v1/fill/w_309,h_255,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Logo_edited.png",
    darkLogo: false,
  },
  {
    name: "OM Immobilier SA",
    note: "",
    website: "https://omimmobilier.ch/",
    logo: "https://omimmobilier.ch/wp-content/uploads/2023/10/Logo_OM_RVB-2.png",
    darkLogo: false,
  },
  {
    name: "OML Immo Sàrl",
    note: "",
    website: "https://www.omlimmo.ch/",
    logo: "https://omlimmo.ch/wp-content/uploads/2025/12/973051-big-120x57.png",
    darkLogo: false,
    boost: true,
  },
  {
    name: "REGIE BULLE Immobilier",
    note: "",
    website: "https://www.regie-bulle.ch/",
    logo: "https://www.regiebulle.ch/wp-content/uploads/2023/11/LogoRBulle_Small.png",
    darkLogo: false,
  },
  {
    name: "Régie Châtel SA",
    note: "",
    website: "https://www.regiechatel.ch/",
    logo: "https://static.immomigsa.ch/courtage/322/pictures/logo_web_650x180.png?1772552939",
    darkLogo: false,
    boostXl: true,
  },
  {
    name: "Régimo Lausanne SA",
    note: "",
    website: "https://www.regimo.ch/",
    logo: "https://www.regimo.ch/_assets/9ef48880d785cc7ef4d1fd91724f2b9f/Icons/Logos/logo-regimo.svg",
    darkLogo: true,
    darkCard: true,
  },
  {
    name: "REGIS SA",
    note: "",
    website: "https://www.regis-sa.ch/",
    logo: "https://www.immomigimg.ch/s/b7179/29/websites/logos/29_3498_d79a40b6c8083e762d5f7edb57b896b11ec08fb0.png",
    darkLogo: false,
  },
  {
    name: "Wincasa AG",
    note: "",
    website: "https://www.wincasa.ch/",
    logo: "https://public.readdy.ai/ai/img_res/b3a4186e-9b13-445b-a269-63033b33b1a4.png",
    darkLogo: false,
    darkCard: false,
    boostXl: true,
  },
  {
    name: "ABC Gérances SA",
    note: "",
    website: "https://abcgerances.ch/",
    logo: "https://public.readdy.ai/ai/img_res/aa2791be-831f-4cdf-8041-a039b0dc8b26.png",
    darkLogo: false,
  },
  {
    name: "SB Management",
    note: "",
    website: "https://bidawid.ch/",
    logo: "https://public.readdy.ai/ai/img_res/1dc89528-b736-44fc-9535-481bfca93f27.png",
    darkLogo: false,
    boostXl: true,
  },
];